window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows),
      sliderGrid = "column",
      sliderLoop = e.dataset.loop;

    if (sliderLoop === "true") {
      sliderLoop = true;
    } else {
      sliderLoop = false;
    }

    if (sliderRows > 1) {
      sliderGrid = "row";
      sliderLoop = false;
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }

    var swiper = new Swiper(sliderContainer, {
      loop: sliderLoop,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      grid: {
        rows: sliderRows,
        fill: sliderGrid,
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: e.querySelector(".product_slider_wrapper .swiper-button-next"),
        prevEl: e.querySelector(".product_slider_wrapper .swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: largeDesktopShow,
        },
        1200: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");

      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };

    slideThumbHeight();

    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }

  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerStickyModule = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  sections.register("header", theme.headerCategoryMenu);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("product-tab", theme.productTab);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("faq-collapse", theme.accordion);
  sections.register("popup-video", theme.video);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});

(() => {
  const HOLD_BEFORE_DOCK = 500;
const DOCK_DURATION = 900;
const BG_FADE_DELAY = 500;
const HANDOFF_DURATION = 120;

  let civettaEntranceHasRun = false;

  function waitForImage(img) {
    return new Promise((resolve) => {
      if (!img) return resolve();

      if (img.complete && img.naturalWidth > 0) {
        return resolve();
      }

      img.addEventListener("load", resolve, { once: true });
      img.addEventListener("error", resolve, { once: true });

      setTimeout(resolve, 1800);
    });
  }

  function waitFrames(count = 2) {
    return new Promise((resolve) => {
      const step = () => {
        count -= 1;

        if (count <= 0) resolve();
        else requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    });
  }

  function getActiveHeaderLogo() {
    const selectors = [
      "a.header__logo_link img.header__heading-logo",
      ".header__heading-logo",
      "a.header__logo_link img",
    ];

    const candidates = [];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((img) => {
        if (candidates.includes(img)) return;

        if (
          img.closest(".mobile-offcanvas-menu") ||
          img.closest("[id^='offcanvas-']") ||
          img.closest("#civettaEntrance")
        ) {
          return;
        }

        const style = window.getComputedStyle(img);
        const rect = img.getBoundingClientRect();

        if (
          img.tagName.toLowerCase() === "img" &&
          style.display !== "none" &&
          style.visibility !== "hidden" &&
          rect.width > 20 &&
          rect.height > 5
        ) {
          candidates.push(img);
        }
      });
    });

    if (!candidates.length) return null;

    const viewportCenter = window.innerWidth / 2;

    candidates.sort((a, b) => {
      const ar = a.getBoundingClientRect();
      const br = b.getBoundingClientRect();

      const aCenter = ar.left + ar.width / 2;
      const bCenter = br.left + br.width / 2;

      return (
        Math.abs(aCenter - viewportCenter) -
        Math.abs(bCenter - viewportCenter)
      );
    });

    return candidates[0];
  }

  function snapToDevicePixel(value) {
    const ratio = window.devicePixelRatio || 1;
    return Math.round(value * ratio) / ratio;
  }

  function getDockTransform(startRect, targetRect) {
    const scale = targetRect.width / startRect.width;
    const finalWidth = startRect.width * scale;
    const finalHeight = startRect.height * scale;
    const finalX = snapToDevicePixel(
      targetRect.left + targetRect.width / 2 - finalWidth / 2
    );
    const finalY = snapToDevicePixel(
      targetRect.top + targetRect.height / 2 - finalHeight / 2
    );

    return {
      scale,
      transform: `translate3d(${finalX}px, ${finalY}px, 0) scale(${scale.toFixed(
        6
      )})`,
    };
  }

  async function initCivettaEntrance() {
    if (civettaEntranceHasRun) return;
    civettaEntranceHasRun = true;

    const entrance = document.getElementById("civettaEntrance");
    if (!entrance) return;

    const logo = entrance.querySelector(".civetta-entrance__logo");
    if (!logo) return;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    const activeTarget = getActiveHeaderLogo();
    let dockFinished = false;

    entrance.classList.add("is-active");

    const unlockPage = () => {
      document.body.classList.remove("civetta-entrance-lock");
      document.body.style.removeProperty("--scroll-padding");
    };

    const closeEntrance = () => {
      entrance.classList.add("is-exiting");

      setTimeout(() => {
        document.body.classList.remove("civetta-logo-is-docking");
        document.body.classList.remove("civetta-entrance-logo-hide");
        activeTarget?.classList.remove("civetta-header-logo-target");

        if (entrance && entrance.parentNode) {
          entrance.remove();
        }
      }, 280);
    };

    if (!activeTarget || reducedMotion) {
      document.body.classList.add("civetta-header-logo-ready");
      entrance.classList.add("is-fading");
      setTimeout(closeEntrance, 450);
      return;
    }

    await Promise.all([
      waitForImage(logo),
      waitForImage(activeTarget),
      document.fonts && document.fonts.ready
        ? document.fonts.ready
        : Promise.resolve(),
    ]);

    await waitFrames(3);

    const unlockedTargetRect = activeTarget.getBoundingClientRect();
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    if (scrollbarWidth > 0) {
      document.body.style.setProperty(
        "--scroll-padding",
        `${scrollbarWidth}px`
      );
    }

    document.body.classList.add("civetta-entrance-lock");

    setTimeout(async () => {
      activeTarget.classList.add("civetta-header-logo-target");

      await waitFrames(2);

      const startRect = logo.getBoundingClientRect();

      if (!startRect.width || !unlockedTargetRect.width) {
        unlockPage();
        document.body.classList.add("civetta-header-logo-ready");
        entrance.classList.add("is-fading");
        setTimeout(closeEntrance, 350);
        return;
      }

      const startX = snapToDevicePixel(startRect.left);
      const startY = snapToDevicePixel(startRect.top);
      const dock = getDockTransform(startRect, unlockedTargetRect);

      logo.classList.remove("is-docking");
      logo.style.left = "0px";
      logo.style.top = "0px";
      logo.style.transition = "none";
      logo.style.transformOrigin = "top left";
      logo.style.transform = `translate3d(${startX}px, ${startY}px, 0) scale(1)`;

      await waitFrames(2);

      logo.classList.add("is-docking");
      document.body.classList.add("civetta-logo-is-docking");
      logo.style.transition = "";
      logo.style.transform = dock.transform;

      setTimeout(() => {
        entrance.classList.add("is-fading");
      }, BG_FADE_DELAY);

      const finishDock = async () => {
        if (dockFinished) return;
        dockFinished = true;

        logo.removeEventListener("transitionend", onTransitionEnd);
        logo.classList.remove("is-docking");
        logo.style.transition = "none";
        logo.style.transform = dock.transform;

        unlockPage();

        await waitFrames(2);

        const settledTargetRect = activeTarget.getBoundingClientRect();
        const settledDock = getDockTransform(startRect, settledTargetRect);
        logo.style.transform = settledDock.transform;

        await waitFrames(1);

        document.body.classList.add("civetta-header-logo-ready");
        logo.style.transition = `opacity ${HANDOFF_DURATION}ms ease-out`;

        requestAnimationFrame(() => {
          logo.style.opacity = "0";
        });

        setTimeout(() => {
          document.body.classList.add("civetta-entrance-logo-hide");
          closeEntrance();
        }, HANDOFF_DURATION);
      };

      const onTransitionEnd = (event) => {
        if (event.propertyName === "transform") {
          finishDock();
        }
      };

      logo.addEventListener("transitionend", onTransitionEnd);

      setTimeout(() => {
        finishDock();
      }, DOCK_DURATION + 350);
    }, HOLD_BEFORE_DOCK);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCivettaEntrance);
  } else {
    initCivettaEntrance();
  }
})();

